import { Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

type DetailRowProps = {
  label: string;
  icon?: ReactNode;
  children: ReactNode;
};

const DetailRow = ({ label, icon, children }: DetailRowProps) => (
  <Stack direction="row" alignItems="center" gap={3} paddingY={3} sx={{ '& > .MuiSvgIcon-root': { fontSize: 18 } }}>
    {icon}
    <Typography sx={{ flex: 1, fontSize: 15, color: 'text.secondary' }}>{label}</Typography>
    <Typography component="div" sx={{ fontSize: 15, fontWeight: 600, textAlign: 'right' }}>
      {children}
    </Typography>
  </Stack>
);

export default DetailRow;
